// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import Content from "../../content/about-us/nos-valeurs.json"
import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import Img from "gatsby-image"

const Card = ({ fixed, text }) => (
  <div
    sx={{
      backgroundColor: colors.white,
      borderRadius: `20px`,
      boxShadow: `0 0 35px 0 rgba(31, 31, 31, 0.07)`,
      width: `14.3rem`,
      height: `9.7rem`,
      display: `flex`,
      flexDirection: `column`,
      alignItems: `center`,
      mt: `6rem`,
    }}
  >
    <div sx={{ height: `5rem` }} />
    <div
      sx={{
        position: "relative",
        top: "-5rem",
        height: 0,
      }}
    >
      <Img fixed={fixed} alt="card-img" />
    </div>
    <div
      sx={{
        display: `flex`,
        alignItems: `end`,
        height: `100%`,
        paddingTop: `5rem`,
      }}
    >
      <p
        sx={{
          color: colors.code.secondary,
          fontSize: `1rem`,
          lineHeight: 1.63,
          letterSpacing: `1.6px`,
          textTransform: `uppercase`,
          fontWeight: fontWeights.bold,
          textAlign: `center`,
          paddingBottom: `0.5rem`,
        }}
      >
        {text}
      </p>
    </div>
  </div>
)

const NosValeursCardsMobile = ({ langKey, overrideCSS }) => {
  const data = useStaticQuery(graphql`
    query NosValeursCardMobileQuery {
      img1: file(relativePath: { eq: "peoples.png" }) {
        childImageSharp {
          fixed(width: 120, height: 120) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      img2: file(relativePath: { eq: "inovation.png" }) {
        childImageSharp {
          fixed(width: 120, height: 120) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      img3: file(relativePath: { eq: "excellence.png" }) {
        childImageSharp {
          fixed(width: 120, height: 120) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  const { pic1Title, pic2Title, pic3Title } = Content[langKey]

  return (
    <div
      sx={{
        display: `flex`,
        flexDirection: `column`,
        alignItems: `center`,
        ...overrideCSS,
      }}
    >
      <Card fixed={data.img1.childImageSharp.fixed} text={pic1Title} />
      <Card fixed={data.img2.childImageSharp.fixed} text={pic2Title} />
      <Card fixed={data.img3.childImageSharp.fixed} text={pic3Title} />
    </div>
  )
}

export default NosValeursCardsMobile
